export const START_DEMO_LABEL = 'مشاهده دمو';
export const START_TRIAL_LABEL = 'ERP خودم رو می‌خوام بسازم';
export const START_LOGIN_LABEL = 'قبلاً ERP خودم رو ساخته‌ام';
